import React from 'react';
import { ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
import { SECURITY_ITEMS, DEMO_URL } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
export function SecuritySection() {
  return <section id="security" aria-labelledby="security-heading" className="border-b border-hairline-soft bg-surface" data-id="element-355" data-mp="3p0l86wrxnczu">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-356" data-mp="gmw1fgi6luqz">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end" data-id="element-357" data-mp="ljmio75q2wdz">
          <SectionHeading eyebrow="Security" headingId="security-heading" title="Your Most Sensitive Deals Require Institutional-Grade Infrastructure." data-id="element-358" data-mp="6o6jjnqacaaq" />
          <Reveal delay={0.06} data-id="element-359" data-mp="2rdcon7bhse0h">
            <CtaButton href={DEMO_URL} event="security_cta_click" variant="outline" size="lg" data-id="element-360" data-mp="2rc2rckcgr9uw">
              Discuss Security on a Demo
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-361" data-mp="16fljcoyariwd" />
            </CtaButton>
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-3" data-id="element-362" data-mp="11ha7k8ofyybi">
          {SECURITY_ITEMS.map((item, index) => <Reveal key={item.title} as="li" delay={index * 0.04} className="flex flex-col gap-3 bg-panel p-6" data-id="element-363" data-mp="1agox95wsb4uy" data-mpi={index}>
              <ShieldCheckIcon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-364" data-mp="1pdnz0d4yg3hi" />
              <h3 className="text-base font-semibold tracking-[-0.01em] text-text-primary" data-id="element-365" data-mp="1kfmk84ekaqbu">{item.title}</h3>
              <p className="text-sm leading-relaxed text-text-secondary" data-id="element-366" data-mp="1y7avk5gzlarr">{item.body}</p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}